// Detail builders for the system panel dialogs (part 1).
export const DETAILS_A = {
  code: (d, t) => ({
    title: t("system.code"),
    summary: [
      [t("system.files"), d.files],
      [t("system.lines"), d.lines.toLocaleString("en-GB")],
      [t("system.endpoints"), d.endpoints],
      [t("system.compliance", { max: d.max_lines_rule }), `${d.compliance_percent}%`],
      [t("system.backendFiles"), d.parts.backend.files],
      [t("system.frontendFiles"), d.parts.frontend.files],
    ],
    columns: [t("system.file"), t("system.linesShort")],
    filters: [
      { key: "oversized", label: t("system.oversizedOnly"), test: (row) => Number(row[1]) > d.max_lines_rule },
      { key: "backend", label: t("system.backendFiles"), test: (row) => String(row[0]).startsWith("backend/") },
      { key: "frontend", label: t("system.frontendFiles"), test: (row) => String(row[0]).startsWith("frontend/") },
      { key: "project", label: t("system.myFiles"), test: (row) => !String(row[0]).includes("components/ui/") },
      { key: "library", label: t("system.libraryFiles"), test: (row) => String(row[0]).includes("components/ui/") },
    ],
    rows: [...(d.parts.backend.all || d.parts.backend.oversized), ...(d.parts.frontend.all || d.parts.frontend.oversized)]
      .sort((a, b) => b.lines - a.lines)
      .map((f) => [f.file, f.lines]),
  }),

  performance: (d, t) => ({
    title: t("system.performance", { hours: d.window_hours }),
    summary: [
      [t("system.requests"), d.requests],
      [t("system.avgMs"), `${d.avg_ms} ms`],
      [t("system.maxMs"), `${d.max_ms} ms`],
      [t("system.serverErrors"), d.server_errors],
      [t("system.clientErrors"), d.client_errors],
      [t("system.uptime"), `${d.uptime_hours} h`],
    ],
    columns: [t("system.path"), t("system.avgMs"), t("system.hits")],
    rows: d.slowest_paths.map((p) => [p.path, `${p.avg_ms} ms`, p.hits]),
  }),

  storage: (d, t) => ({
    title: t("system.storage"),
    summary: [
      [t("system.dbSize"), `${d.db_size_mb} MB`],
      [t("system.indexSize"), `${d.index_size_mb} MB`],
      [t("system.documents"), d.documents.toLocaleString("en-GB")],
      [t("system.collections"), d.collection_count],
      [t("system.disk"), `${d.disk_used_percent}%`],
      [t("system.memory"), `${d.memory_percent}%`],
      [t("system.cpu"), `${d.cpu_percent}%`],
      [t("system.freeGb", { gb: d.disk_free_gb }), `${d.storage_size_mb} MB`],
    ],
    columns: [t("system.collection"), t("system.documents")],
    rows: d.collections.map((c) => [c.name, c.documents]),
  }),

  geo: (d, t) => ({
    title: t("system.geo", { days: d.days }),
    summary: [
      [t("system.uniqueIps"), d.unique_ips],
      [t("system.resolvedIps"), d.resolved_ips],
      [t("system.countriesCount"), d.countries.length],
    ],
    columns: [t("system.country"), t("system.requests"), t("system.ips")],
    rows: d.countries.map((c) => [c.country, c.requests, c.devices]),
  }),
};
